import { USER_AUTHENTICATED_LOGIN,USER_TYPE, USER_TOKEN, UPDATE_USER_TAGS, IS_USER_INFO_UPDATING } from './keys'
const initialState = { userData: null, token: null, userTags: null , userInfo_updating:false}
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case USER_AUTHENTICATED_LOGIN: {    
            return { ...state, userData: action.payload,  }
        }
        case USER_TYPE: {     
            return { ...state, state : state.userData.user.lastThemeStatus = action.payload }
        }
        case USER_TOKEN: {
            return { ...state, token: action.payload }
        }
        case IS_USER_INFO_UPDATING:{
            return { ...state, userInfo_updating: action.payload }
        }
        case UPDATE_USER_TAGS: {
            return { ...state, userTags: action.payload }
        }

        default:
            return { ...state }
    }

}